import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, Zap, Check } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-10" data-id="element-124">
      {/* Softer urgency countdown strip */}
      <div className="bg-[#0c0d14] py-2 px-3 text-center border-y border-red-900/20" data-id="element-125">
        <p className="text-red-400/80 font-semibold text-xs md:text-sm tracking-tight mb-1 uppercase" data-id="element-126">
          ⏰ El precio de lanzamiento termina en:
        </p>
        <CountdownTimer className="text-red-400/80 mb-0.5" data-id="element-127" />
        <p className="text-red-500/60 font-medium text-[9px] md:text-[10px] uppercase tracking-tight mt-1" data-id="element-128">
          Después sube el precio y no vuelve a bajar.
        </p>
        <div className="max-w-xs mx-auto mt-1.5" data-id="element-129">
          <div className="flex justify-between text-[9px] font-medium mb-0.5 uppercase tracking-tight" data-id="element-130">
            <span className="flex items-center text-red-400/80" data-id="element-131">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500/70 mr-1 animate-ping" data-id="element-132"></span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-red-500/60" data-id="element-133">Quedan pocos</span>
          </div>
          <div className="w-full bg-[#08090f] rounded-full h-1.5 overflow-hidden border border-red-900/15" data-id="element-134">
            <div className="bg-red-500/60 h-1.5 rounded-full w-[78%]" data-id="element-135"></div>
          </div>
          <p className="text-[8px] text-red-500/50 font-medium mt-0.5 text-right" data-id="element-136">
            78% de los cupos tomados
          </p>
        </div>
      </div>

      {/* Pricing section */}
      <div className="py-4 md:py-6 px-3 bg-brand-cardAlt" data-id="element-137">
        <div className="max-w-xl mx-auto" data-id="element-138">
          <div className="bg-brand-card rounded-2xl border border-white/15 p-4 md:p-6 flex flex-col relative" data-id="element-139">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-white font-semibold px-4 py-1 rounded-full text-[10px] md:text-xs tracking-tight shadow-md whitespace-nowrap uppercase" data-id="element-140">
              🏆 OFERTA ÚNICA
            </div>

            <h3 className="text-base md:text-xl font-bold text-white mb-1 mt-2 leading-tight text-center uppercase tracking-tight" data-id="element-141">
              KIT COMPLETO PROGRAMACIÓN LISTA
            </h3>
            <p className="text-white font-medium text-[10px] md:text-xs mb-3 text-center tracking-tight" data-id="element-142">
              Los 6 tomos + 4 bonos estratégicos + Actualizaciones de por vida
            </p>

            {/* Checklist */}
            <div className="bg-brand-dark/50 rounded-xl border border-white/5 p-3 mb-3" data-id="element-143">
              <p className="text-[10px] text-white font-semibold uppercase tracking-tight mb-2 border-b border-white/10 pb-1" data-id="element-144">
                Todo lo que recibís hoy:
              </p>
              <ul className="space-y-1 text-[10px] md:text-[11px] font-normal text-white" data-id="element-145">
                <li className="flex items-center" data-id="element-146">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-147" />{' '}
                  📘 Tomo 1 — Fundamentos de la Programación
                </li>
                <li className="flex items-center" data-id="element-148">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-149" />{' '}
                  📗 Tomo 2 — Estructuras Básicas
                </li>
                <li className="flex items-center" data-id="element-150">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-151" />{' '}
                  📙 Tomo 3 — Estructuras Repetitivas
                </li>
                <li className="flex items-center" data-id="element-152">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-153" />{' '}
                  📕 Tomo 4 — Funciones y Modularidad
                </li>
                <li className="flex items-center" data-id="element-154">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-155" />{' '}
                  📓 Tomo 5 — Estructuras de Datos
                </li>
                <li className="flex items-center" data-id="element-156">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-157" />{' '}
                  📔 Tomo 6 — Aplicaciones Prácticas
                </li>
                <li className="flex items-center text-brand-gold mt-1 pt-1 border-t border-white/5" data-id="element-158">
                  <Check className="w-3 h-3 text-brand-gold mr-1.5 shrink-0" data-id="element-159" />{' '}
                  🎁 Guía de Planificación Anual (USD 15)
                </li>
                <li className="flex items-center text-brand-gold" data-id="element-160">
                  <Check className="w-3 h-3 text-brand-gold mr-1.5 shrink-0" data-id="element-161" />{' '}
                  🎁 Banco de Ejercicios Anti-IA (USD 12)
                </li>
                <li className="flex items-center text-brand-gold" data-id="element-162">
                  <Check className="w-3 h-3 text-brand-gold mr-1.5 shrink-0" data-id="element-163" />{' '}
                  🎁 Errores Comunes + Cómo Explicarlos (USD 10)
                </li>
                <li className="flex items-center text-brand-gold" data-id="element-164">
                  <Check className="w-3 h-3 text-brand-gold mr-1.5 shrink-0" data-id="element-165" />{' '}
                  🎁 Evaluaciones Listas con Rúbrica (USD 9)
                </li>
                <li className="flex items-center text-white mt-1 pt-1 border-t border-white/5" data-id="element-166">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-167" />{' '}
                  ✅ Actualizaciones de por vida
                </li>
                <li className="flex items-center text-white" data-id="element-168">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-169" />{' '}
                  ✅ Acceso inmediato en 5 minutos
                </li>
                <li className="flex items-center text-white" data-id="element-170">
                  <Check className="w-3 h-3 text-brand-cta mr-1.5 shrink-0" data-id="element-171" />{' '}
                  ✅ Garantía de 7 días sin preguntas
                </li>
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-3" data-id="element-172">
              <span className="text-[11px] text-gray-500 line-through font-medium mb-0.5" data-id="element-173">
                Precio normal: USD 45.00
              </span>
              <div className="flex items-baseline gap-1.5" data-id="element-174">
                <span className="text-xs font-semibold text-brand-cta" data-id="element-175">
                  🔥 HOY:
                </span>
                <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-176">
                  USD 19,90
                </span>
              </div>
            </div>

            <Button href="https://kit-online-2026.myshopify.com/cart/44553745694855:1" className="py-3 md:py-4 text-sm md:text-lg shadow-[0_0_20px_rgba(0,255,136,0.25)] w-full" pulse={true} data-id="element-177">
              💻 → QUIERO EL KIT COMPLETO
            </Button>
          </div>

          {/* Trust badges - prominent */}
          <div className="bg-brand-card rounded-xl border border-white/10 p-3 mt-3 mb-2" data-id="element-178">
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-[10px] md:text-xs text-white font-semibold uppercase tracking-tight" data-id="element-179">
              <div className="flex items-center" data-id="element-180">
                <Lock className="w-4 h-4 mr-1.5 text-brand-cta" data-id="element-181" /> Pago 100%
                seguro
              </div>
              <div className="flex items-center" data-id="element-182">
                <Zap className="w-4 h-4 mr-1.5 text-brand-cta" data-id="element-183" /> Acceso en 5
                min
              </div>
              <div className="flex items-center" data-id="element-184">
                <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-cta" data-id="element-185" />{' '}
                Garantía 7 días
              </div>
            </div>
          </div>

          {/* Currency text - legible */}
          <div className="bg-brand-card/50 rounded-xl border border-white/5 p-3 mt-1" data-id="element-186">
            <p className="text-[10px] md:text-xs text-gray-300 text-center font-normal leading-relaxed" data-id="element-187">
              El precio está en dólares estadounidenses (USD). El cobro se
              realiza automáticamente en la moneda de tu país al tipo de cambio
              del momento. Pagás en pesos argentinos, pesos mexicanos, pesos
              colombianos, soles peruanos, pesos chilenos, guaraníes, bolívares,
              quetzales, lempiras, colones, balboas, córdobas o cualquier otra
              moneda local según tu país de origen.
            </p>
          </div>
        </div>
      </div>
    </section>;
}